//
//
//
//
//
//
//
//
//
//

import { getUser } from "@/common/js/cache";
import { getHomeList } from "@/api/home";
import { mapGetters, mapActions } from 'vuex'
import { childWebsite } from "@/common/js/config";

export default {
  name: "app",
  data(){
    return {
      statis:''
    }
  },
  computed:{
    ...mapGetters(['college'])
  },
  created() {
    (function(doc, win) {
      var docEl = doc.documentElement,
        resizeEvt =
          "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function() {
          var clientWidth = docEl.clientWidth;
          if (!clientWidth) return;
          var val = Number(200 * (clientWidth / 750));
          docEl.style.fontSize = val > 200 ? "200px" : val + "px";
        };

      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);
    })(document, window);

    //获取用户
    if(getUser()){
    }else{
      this.$store.commit('CLEAR_USER')
    }

  },
  mounted(){
  },
  methods:{
  }
};



// WEBPACK FOOTER //
// ./src/App.vue